module.exports = __webpack_public_path__ + "img/smiley.34b09e44.svg";